import { render, staticRenderFns } from "./CollapsableButtons.vue?vue&type=template&id=5f166316&scoped=true"
import script from "./CollapsableButtons.vue?vue&type=script&lang=js"
export * from "./CollapsableButtons.vue?vue&type=script&lang=js"
import style0 from "./CollapsableButtons.vue?vue&type=style&index=0&id=5f166316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f166316",
  null
  
)

export default component.exports